import React, { useState, useEffect } from "react";
import "../style/eventexpo.css";
import imgesone from '../../../assets/images/eventbanner.jpg';

const EventExpo = () => {
    const [loading, setLoading] = useState(true);
      useEffect(() => {
        setLoading(false);
      }, []);

      // Hide section if no API data
      if (!loading && EventExpo.length === 0) {
        return null;
      }
  return (
      <section className="EventExpo">
        <div className="container"> 
           <img src={imgesone} alt="event banner" loading="lazy"/>
        </div>
      </section>
  );
};
export default EventExpo;